exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigator ul.el-menu {\n  background-color: #095b69;\n}\n.navigator ul.el-menu .el-menu-item {\n  color: aliceblue !important;\n}", ""]);

// exports
